export default "__VITE_ASSET__f88d83ec__"